import * as angular from "angular";
import "angular-simple-logger";
import { House } from "../../models/house.model";

let HouseAddressComponent = {
    selector: "vcHouseAddress",
    templateUrl: "/angular/components/house/house-address.component.html",
    bindings: {
        house: "=",
    },
    controller: class HouseAddressController {
        // * bindings for typescript compiler *
        public house?: House;
        // ************************************
    },
};

angular
    .module("house", [
        "uiGmapgoogle-maps",
        "nemLogging",
        "checkManager",
        "angular-inview",
    ])
    .component(HouseAddressComponent.selector, HouseAddressComponent);
